import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import {
  Dialog, DialogContent, DialogFooter, DialogTitle,
} from '../../../components/base/Dialog/Dialog';
import {
  Button, Icons,
} from '../../../components/base/BootstrapComponents/BootstrapComponents';
import Grid from '../../../components/base/Grid/Grid';
import Switches from '../../../components/fields/Switches/Switches';
import { getZoneData } from '../reducer';
import { getActionLogData } from '../../../utils/formatters';

export default function HistoryDialog({ onClose = () => {} }) {
  const { currentHistory = {} } = useSelector(getZoneData);
  const [switchValue, setSwitchValue] = useState(false);
  const columns = [
    {
      dataField: 'name',
      text: 'Имя поля',
      disableSort: true,
    },
    {
      dataField: 'prev',
      text: 'Данные до изменений',
      headerClassName: 'module-column',
      disableSort: true,
    },
    {
      dataField: 'new',
      text: 'Данные после изменений',
      headerClassName: 'module-column',
      disableSort: true,
    },
    {
      dataField: 'current',
      text: 'Текущее значение',
      headerClassName: 'module-column',
      disableSort: true,
    },
  ];

  // Огромный костыль созданный по просьбе Погребца
  const list = getActionLogData(currentHistory);
  const gridData = switchValue ? list?.filter(e => e.prev !== e.new) || [] : list || [];
  return (
    <Dialog
      onClose={() => { onClose(); }}
      size="xl"
      open
    >
      <DialogTitle
        header="История изменений зоны"
        title={<Icons width={14} height={14} customIcon icon="clear" className="pointer" onClick={onClose} />}
      />
      <DialogContent>
        <div className="d-flex flex-row">
          <div>Внесенные изменения</div>
          <Switches
            withLabel
            label="Только изменения"
            className="ms-auto"
            inputProps={{
              value: switchValue,
              onChange: () => {
                setSwitchValue(!switchValue);
              },
            }}
            placeholder="Select input placeholder"
            variant="material"
            inverse
          />
        </div>
        <div className="registry-history-table">
          <Grid
            data={gridData}
            columns={columns}
            name="application-list"
          />
        </div>
      </DialogContent>
      <DialogFooter className="hff-footer">
        <Button
          variant="secondary"
          onClick={() => {
            onClose();
          }}
        >Закрыть
        </Button>
      </DialogFooter>
    </Dialog>
  );
}
